export default "__VITE_ASSET__CMwWVjaq__"